import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-error-solid",
  "use": "icon-error-solid-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-error-solid\"><path fill=\"#ff3030\" fill-rule=\"evenodd\" d=\"M8 15c3.9 0 7-3.1 7-7s-3.1-7-7-7-7 3.1-7 7 3.1 7 7 7\" clip-rule=\"evenodd\" /><path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M8.8 11v1.5H7.3V11zm0-7v6H7.3V4z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol